import { React, useState } from 'react'
import '../CSS/Blogs/Blogs.css'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'
import { Link } from 'react-router-dom'
import Cards from './Cards'
import CardData from "../../data.json"
import '../CSS/DarkMode/Blogs/Blogs.css'
import arrow from '../../Images/Icons/ArrowRight.svg'
import BackTop from '../Buttons/BackTop'
import BackTopBar from '../Buttons/BackTopBar'

const Blogs = () => {

  const [NavSize, SetNavSize] = useState("80%")


  window.addEventListener("load", () => {

    if (window.innerWidth <= 768) {
      SetNavSize("90%")
    } else {
      SetNavSize("80%")

    }
  })
  return (
    <>
      <BackTop />
      <BackTopBar />
      <Navbar width={NavSize} />
      <div className='ParentRapper' id='Blogs'>
        <section className="blogSection" >
          <div className="blogback">
            <div className="blogHero">
              <div className="heroBody">
                <Link to="/about">Back to About Us</Link>
                <h1>New at Martian Blogs</h1>
                <p className='resMobVer'>A collection of stories about our people, our capabilities, our research, and the ever-changing face of our firm.</p>
              </div>
              <div className="blogCards">
                <div className="cardBody">
                  <div className="cardSectionheader">
                    <div className="headerTitle">
                      <h1>BROWSE ALL POSTS</h1>
                      <div className="blogCardSectionHeaderFilter">
                        <div className="blogCardSectionHeaderFiltertitle">Browse by:</div>
                        <button className='blogCardHeaderFilterBtn'>Topic</button>
                        <button type="button " className='blogCardHeaderFilterBtn'>Date</button>
                      </div>
                    </div>
                  </div>
                  <div className="blogCards">
                    {
                      CardData.slice(0, 2).map((data) => {
                        return (<Cards image={data.image} title={data.title} date={data.date} desc={data.description} type={data.type} key={data.slno} linkto={data.linkto} />)
                      })
                    }
                    <div className='SubscribeCont sbResDptVer'>
                      <h1>Never miss any story</h1>
                      <p>Stay effortlessly informed with real-time updates on Martian Blogs ensuring you never miss a single story or development from the fascinating world of Mars exploration and discovery.</p>
                      <div className="inputArrowCont">
                        <input type="email" placeholder='Email Id' />
                        <img src={arrow} alt="Arrow" />
                      </div>
                    </div>
                    {
                      CardData.slice(2, CardData.length).map((data) => {
                        return (<Cards image={data.image} title={data.title} date={data.date} desc={data.description} type={data.type} key={data.slno} linkto={data.linkto} />)
                      })
                    }
                    <div className='SubscribeCont sbResMobVer'>
                      <h1>Never miss any story</h1>
                      <p>Stay effortlessly informed with real-time updates on Martian Blogs ensuring you never miss a single story or development from the fascinating world of Mars exploration and discovery.</p>
                      <div className="inputArrowCont">
                        <input type="email" placeholder='Email Id' />
                        <img src={arrow} alt="Arrow" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer width="100%" />
      </div>
    </>
  )
}

export default Blogs